import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

// Safe logo component (assumes all logos are PNG format)
const SafeLogo = ({ context = 'light', className = '', alt, ...props }) => {
  const { brand } = useTheme();

  // Get logo path with PNG format
  const getLogoPath = () => {
    const primaryLogo = brand.getLogo(context);
    
    if (!primaryLogo) {
      return getFallbackLogo(context);
    }

    // Ensure path has .png extension
    if (primaryLogo.match(/\.png$/i)) {
      return primaryLogo;
    }

    // Remove any existing extension and add .png
    const basePath = primaryLogo.replace(/\.(jpg|jpeg|png)$/i, '');
    return `${basePath}.png`;
  };

  const getFallbackLogo = (context) => {
    switch (context) {
      case 'dark':
      case 'footer':
        return '/assets/logos/default-logo-white.png';
      case 'light':
      case 'navbar':
      default:
        return '/assets/logos/default-logo.png';
    }
  };

  const logoPath = getLogoPath();

  return (
    <img
      src={logoPath}
      alt={alt || brand.name}
      className={className}
      onError={(e) => {
        // Fallback to default logo on error
        e.target.src = getFallbackLogo(context);
      }}
      {...props}
    />
  );
};

export default SafeLogo;
